import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { Card, CardContent } from "@/shared/ui/card";

import type { GeoRunSummary } from "../../../api/geoService";

/** 总分趋势:历史 SUCCESS 轮次折线(手动轮次口径,每跑一轮长一个点)。 */
export function TrendLine({ runs }: { runs: GeoRunSummary[] }) {
  const points = runs
    .filter((r) => r.status === "SUCCESS" && r.overallScore != null)
    .map((r) => ({
      id: r.id,
      date: (r.createdAt ?? "").slice(5, 10),
      score: r.overallScore as number,
    }))
    .reverse(); // 列表新在前 → 折线旧在前
  if (points.length < 2) return null;
  return (
    <Card>
      <CardContent className="p-6">
        <div className="text-sm font-medium">总分趋势</div>
        <div className="mt-1 text-xs text-muted-foreground">
          每轮监测自动记录 · 近 {points.length} 轮
        </div>
        <div className="mt-2 h-44" data-testid="geo-trend-line">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={points} margin={{ top: 8, right: 12, bottom: 0, left: -18 }}>
              <CartesianGrid stroke="hsl(var(--chart-grid))" vertical={false} />
              <XAxis
                dataKey="date"
                tick={{ fill: "hsl(var(--chart-axis))", fontSize: 12 }}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                domain={[0, 100]}
                tick={{ fill: "hsl(var(--chart-axis))", fontSize: 12 }}
                tickLine={false}
                axisLine={false}
              />
              <Tooltip
                contentStyle={{
                  background: "hsl(var(--popover))",
                  border: "1px solid hsl(var(--border))",
                  borderRadius: 8,
                  color: "hsl(var(--popover-foreground))",
                  fontSize: 12,
                }}
                formatter={(v: number) => [`${v} 分`, "总分"]}
              />
              <Line
                type="monotone"
                dataKey="score"
                stroke="hsl(var(--chart-1))"
                strokeWidth={2.5}
                dot={{ r: 3, fill: "hsl(var(--background))", strokeWidth: 2 }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
